/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
import { DEFAULT_CATEGORIES } from 'app/const/categories';
import {
    prevSelectedPeriodsVar, selectedPeriodVar, isSelectedDefaultFiltersVar,
    isUserChangesTagsVar, selectedCategoriesVar, selectedCategoryIdVar,
    selectedTagsVar,
} from '../reaction';

/* REACTIONS */

/*
    prevSelectedPeriodsVar,
    selectedPeriodVar,
    isSelectedDefaultFiltersVar,
    isUserChangesTagsVar,
    selectedCategoriesVar,
    selectedCategoryIdVar,
    selectedTagsVar,
*/

export const _updateIsSelectedDefaultFiltersReaction = () => {
    const selectedCategories = selectedCategoriesVar();
    const selectedTags = selectedTagsVar();

    // В массивах хранятся только id, поэтому достаточно проверить длины
    const isAllCategoriesSelected = selectedCategories.length === DEFAULT_CATEGORIES.length;
    const isTagsNotSelected = selectedTags.length === 0;

    const isSelectedDefaultFilters = isAllCategoriesSelected && isTagsNotSelected;

    isSelectedDefaultFiltersVar(isSelectedDefaultFilters);
};


const areArraysEqual = (left = [], right = []) => {
    if (left.length !== right.length) return false;
    return left.every((value, index) => value === right[index]);
};

/**
 * @param {*} param
 */
export const setDefaultFiltersReaction = ({ variables }) => {
    const {
        periodStart,
        categoryId,
        categories,
        tags,
    } = variables;

    const selectedTags = selectedTagsVar();
    const nextTags = [...new Set([...selectedTags, ...tags])];

    if (
        selectedPeriodVar() === periodStart
        && selectedCategoryIdVar() === categoryId
        && areArraysEqual(selectedCategoriesVar(), categories)
        && areArraysEqual(selectedTags, nextTags)
    ) {
        return;
    }

    selectedPeriodVar(periodStart);
    prevSelectedPeriodsVar([periodStart]);
    selectedCategoryIdVar(categoryId);
    selectedCategoriesVar(categories);
    selectedTagsVar(nextTags);

    _updateIsSelectedDefaultFiltersReaction();
};

/**
 * @param {*} param
 */
export const pickPeriodReaction = ({ periodStart, skipSavingToPrev }) => {
    const prevSelectedPeriods = prevSelectedPeriodsVar();
    const selectedPeriod = selectedPeriodVar();

    if (selectedPeriod !== periodStart) {
        const isNeedeUpdatePrev = !skipSavingToPrev && !prevSelectedPeriods.includes(periodStart);
        const nextPeriods = isNeedeUpdatePrev ? [periodStart, ...prevSelectedPeriods] : prevSelectedPeriods;

        selectedPeriodVar(periodStart);
        prevSelectedPeriodsVar(nextPeriods);
        _updateIsSelectedDefaultFiltersReaction();
    }
};

/**
 * @param {*} param
 */
export const pickCategoryReaction = ({ categoryId }) => {
    selectedCategoryIdVar(categoryId);
    _updateIsSelectedDefaultFiltersReaction();
};

/**
 * @param {*} param
 */
export const setCategoriesReaction = ({ categories }) => {
    selectedCategoriesVar(categories);
    _updateIsSelectedDefaultFiltersReaction();
};
